import { AlertTriangle, ShieldAlert } from 'lucide-react';

export default function DeactivateErrorBanner({
  message,
  kind,
}: {
  message: string;
  kind: 'load' | 'save';
}) {
  const isLastAdmin = /last (active )?Admin/i.test(message);
  return (
    <div
      className={`mx-[22px] ${kind === 'load' ? 'my-4' : 'mb-3'} flex gap-2 items-start text-[12px] rounded-lg px-3 py-2.5 border ${
        isLastAdmin
          ? 'bg-amber-50 border-amber-200 text-amber-900 dark:bg-amber-900/20 dark:border-amber-800 dark:text-amber-200'
          : 'bg-clay-50 border-clay-200 text-clay-800 dark:bg-clay-900/20 dark:border-clay-800 dark:text-clay-300'
      }`}
      role="alert"
    >
      {isLastAdmin ? (
        <ShieldAlert size={14} className="flex-none mt-0.5" />
      ) : (
        <AlertTriangle size={14} className="flex-none mt-0.5" />
      )}
      <span>
        {kind === 'load' ? "Couldn't load impact: " : ''}
        {message}
      </span>
    </div>
  );
}
